import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class ConsolidatedCommissionSelectListCtrl implements IController {
  selectedId: any;
  optionIds: any;
  excludeIds: any;
  accountId: string;
  statuses: any;
  onChange: Function;

  private consolidatedCommissionsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private excludeKeys: any;

  /* @ngInject */
  constructor(private $log, private $consolidatedCommission, private $infiniteScroll) {
  }

  $onInit() {
    this.consolidatedCommissionsRef = this.$consolidatedCommission();
    this.loadLimit = 20;

    this.consolidatedCommissionsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.consolidatedCommissionsRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  private _reload() {
    this.consolidatedCommissionsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      accountId: this.accountId,
      status: this.statuses,
      id: this.optionIds,
      searchTerm: this.queryString,
      sort: 'name,asc'
    };
  }
}

angular
  .module('bringoz.admin.commissions')
  .component('consolidatedCommissionSelectList', {
    bindings: {
      selectedId: '<',
      optionIds: '<?',
      excludeIds: '<?',
      accountId: '<?',
      statuses: '<?',
      onChange: '&'
    },
    template: require('./consolidated-commission-select-list.html').default,
    controller: ConsolidatedCommissionSelectListCtrl
  });
